import axInsecure from '../api-insecure'
/**
 * uploadFile uploads one or more files to the management endpoint.
 *
 * @param {FormData} formData - A FormData instance containing file(s) under the 'file' key.
 * @param {object} [config={}] - Optional Axios request configuration (e.g., onUploadProgress).
 * @returns {Promise<import('axios').AxiosResponse>} The full Axios response object.
 * @throws {Error} When the upload fails, with a message including the underlying error.
 */
export const uploadFile = async (formData, config = {}) => {
	try {
		const response = await axInsecure.post(
			'/management/user/upload-files.php',
			formData,
			{
				headers: { 'Content-Type': 'multipart/form-data' },
				...config
			}
		)
		return response // Ensure this returns the whole response object
	} catch (error) {
		throw new Error(`uploadFile() Upload failed: ${error.message}`)
	}
}
